module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatPop"
    },
    on: {
      "click": function($event) {
        return _vm.bodyClick($event)
      }
    }
  }, [(_vm.$store.state.showChat) ? _c('div', {
    staticClass: "side-bar-wrapper",
    class: {
      'isLogin': _vm.user.id ? true : false
    },
    style: ({
      'right': _vm.scrollWidth
    })
  }, [_c('div', {
    staticClass: "side-bar-box",
    class: {
      'no-login': !_vm.user.id
    },
    on: {
      "click": _vm.showCharPop
    }
  }, [_c('i', {
    staticClass: "iconfont iconkefu"
  }), _vm._v(" "), _c('span', [_vm._v("联系客服")]), _vm._v(" "), _c('div', {
    staticClass: "side-bar-detail-box"
  }, [_c('div', {
    staticClass: "side-bar-detail-item",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openConsultationModal
    }
  }, [_c('Icon', {
    staticStyle: {
      "padding-right": "6px"
    },
    attrs: {
      "type": "chatbubble-working",
      "size": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v("业务咨询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "side-bar-detail-item"
  }, [_c('Icon', {
    staticStyle: {
      "padding-right": "6px"
    },
    attrs: {
      "type": "ios-telephone",
      "size": "16",
      "color": "#ff9100"
    }
  }), _vm._v(" "), _c('span', [_vm._v("联系电话")]), _vm._v(" "), _c('p', [_vm._v("021-36622199")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "side-bar-box",
    class: {
      'no-login': !_vm.user.id
    },
    on: {
      "click": _vm.showCard
    }
  }, [_c('i', {
    staticClass: "iconfont iconren1"
  }), _vm._v(" "), _c('span', [_vm._v("鸭嘴兽联系人")])]), _vm._v(" "), (_vm.isCheckNotice) ? _c('div', {
    staticClass: "side-bar-box",
    class: {
      'no-login': !_vm.user.id
    },
    on: {
      "click": _vm.checkNotice
    }
  }, [_c('i', {
    staticClass: "iconfont icontongzhi"
  }), _vm._v(" "), _c('span', [_vm._v("查看公告")]), _vm._v(" "), (!_vm.isReadFlag) ? _c('i', {
    staticClass: "tip-flag"
  }) : _vm._e(), _vm._v(" "), (_vm.isShowNoticeTip) ? _c('div', {
    staticClass: "side-bar-box notice-pop-tip",
    staticStyle: {
      "top": "20%"
    }
  }, [_c('div', [_vm._v("点击这里可以查看公告啦~")]), _vm._v(" "), _c('span', {
    staticClass: "close-pop-tip",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isShowNoticeTip = false
      }
    }
  }, [_vm._v("✖")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasLogin) ? _c('div', {
    staticClass: "side-bar-box",
    class: {
      'no-login': !_vm.user.id
    },
    on: {
      "click": _vm.goComplaint
    }
  }, [_c('i', {
    staticClass: "iconfont iconjianyi"
  }), _vm._v(" "), _c('span', [_vm._v("投诉与建议")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "side-bar-box",
    class: {
      'no-login': !_vm.user.id
    },
    on: {
      "click": function($event) {
        return _vm.getManualInfo()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont iconyewushouce"
  }), _vm._v(" "), _c('span', [_vm._v("客户使用手册")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerCard.show),
      expression: "customerCard.show"
    }],
    staticClass: "card-customer "
  }, [_c('CustomerCard', {
    ref: "CustomerCardDom",
    attrs: {
      "show-card": _vm.customerCard.show,
      "has-login": _vm.hasLogin
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chat-pop",
    class: {
      hide: _vm.chatPop
    }
  }, [_c('div', {
    staticClass: "chat-box"
  }, [_c('div', {
    staticClass: "top",
    class: {
      'box-width': !_vm.showChatRecord
    }
  }, [_c('img', {
    staticClass: "v",
    attrs: {
      "src": require("../images/touxiang.png"),
      "alt": "鸭嘴兽"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "v"
  }, [_vm._v("联系客服-\n                          "), (_vm.user.customerService) ? _c('span', [_vm._v(_vm._s(_vm.user.customerService))]) : _c('span', [_vm._v("智能客服")]), _vm._v(" "), (_vm.customerServicePhone) ? _c('span', [_vm._v("( 联系电话: " + _vm._s(_vm.customerServicePhone) + " )")]) : _c('span', [_vm._v("( 联系电话: 021-36622199 )")])]), _vm._v(" "), _c('div', {
    staticClass: "r",
    on: {
      "click": _vm.hideChatPop
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "type": "close"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "chat-list-box"
  }, [_c('div', {
    ref: "chatList",
    staticClass: "chat-list",
    on: {
      "scroll": _vm.handleReachTop
    }
  }, [_c('ul', {
    staticClass: "clearfloat"
  }, _vm._l((_vm.questionList), function(msg, index) {
    return (_vm.questionList.length) ? _c('li', {
      staticClass: "clearfloat",
      attrs: {
        "id": 'user-question' + index
      }
    }, [(msg.judge == 0) ? _c('div', {
      staticClass: "r ask"
    }, [_c('div', [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.keepTime(msg.creationTime)) + "  \n                      "), _vm._v(" "), (_vm.hasLogin) ? [_vm._v("\n                        " + _vm._s(msg.createdByName) + "\n                      ")] : [_vm._v("\n                        " + _vm._s(_vm.stranger.named ? _vm.stranger.named : _vm.stranger.mobilePhone) + "\n                      ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "content-box clearfloat"
    }, [(msg.content && !(msg.messageType == 'FILE')) ? _c('div', {
      staticClass: "r content",
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(msg.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (msg.messageType && msg.messageType == 'FILE') ? _c('div', {
      staticClass: "r content file",
      on: {
        "click": function($event) {
          return _vm.downloadFile(msg)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(msg.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(msg.content))])]) : _vm._e()])])]) : _c('div', {
      staticClass: "l replay"
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(msg.createdByName) + "  " + _vm._s(_vm.keepTime(msg.creationTime)))]), _vm._v(" "), _c('div', {
      staticClass: "content-box clearfloat"
    }), _vm._v(" "), _c('div', {
      staticClass: "l content"
    }, [(msg.map.content) ? _c('div', {
      staticClass: "question"
    }, [_c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "name-time"
    }, [_vm._v(_vm._s(msg.map.createdByName) + "  " + _vm._s(_vm.keepTime(msg.map.creationTime)))]), _vm._v(" "), (msg.map.content && !(msg.map.messageType == 'FILE')) ? _c('div', {
      staticClass: "img-cont",
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(msg.map.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (msg.map.messageType && msg.map.messageType == 'FILE') ? _c('div', {
      staticClass: "file",
      on: {
        "click": function($event) {
          return _vm.downloadFile(msg.map)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(msg.map.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(msg.map.content))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (msg.content && !(msg.messageType == 'FILE')) ? _c('div', {
      staticClass: "re-cont",
      staticStyle: {
        "color": "#000"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(msg.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (msg.messageType && msg.messageType == 'FILE') ? _c('div', {
      staticClass: "l file",
      staticStyle: {
        "padding": "5px 7px"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(msg)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(msg.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(msg.content))])]) : _vm._e()])])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wangEditor"
  }, [(_vm.showEmoticon) ? _c('div', {
    staticClass: "emoticon-box"
  }, [_c('ul', {
    staticClass: "emoticon-table"
  }, _vm._l((_vm.emoticonsList), function(v, k) {
    return _c('li', {
      staticClass: "emoticon-item",
      class: v,
      attrs: {
        "title": k
      },
      on: {
        "click": function($event) {
          return _vm.addEmoticon(k)
        }
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toolbar",
    attrs: {
      "id": 'edit-bar-' + _vm.openpage
    }
  }, [_c('div', {
    staticClass: "uploadFileBtn toolBtn"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "headers": _vm.headersObj,
      "format": ['doc', 'docx', 'xls', 'xlsx', 'pptx', 'pdf', 'zip', 'rar'],
      "multiple": false,
      "data": _vm.uploadInfo,
      "before-upload": _vm.handleUpload,
      "show-upload-list": false,
      "on-format-error": _vm.formatError,
      "on-success": _vm.uploadSuccess,
      "action": "/api/harbour-server/messenger/upload/file"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder",
      "size": "14"
    }
  })], 1)], 1), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "history-Btn",
    on: {
      "click": _vm.lookHistoryRecord
    }
  }, [_vm._v("\n                历史消息\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": 'edit-cont-' + _vm.openpage
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getContent($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "overflow": "hidden"
    }
  }, [_c('Button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "background-color": "#02CAD6",
      "border-color": "#02CAD6"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getContent()
      }
    }
  }, [_vm._v("发送")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "record-list-box",
    class: {
      'hide': _vm.showChatRecord
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchInput),
      expression: "searchInput",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getHistoryRecord('search')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-bar"
  }, [_c('Tabs', {
    attrs: {
      "value": _vm.curTabActive,
      "animated": false,
      "size": "small"
    },
    on: {
      "on-click": function($event) {
        return _vm.clickTab($event)
      }
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }, [_c('div', {
    staticClass: "all"
  }, [_vm._l((_vm.histyQuestionList), function(info, index) {
    return (_vm.histyQuestionList.length) ? _c('div', {
      staticClass: "record"
    }, [(info.parentId == 0) ? _c('div', {
      staticClass: "cont-box clearfloat"
    }, [_c('div', {
      staticClass: "l content"
    }, [_c('div', [_c('div', {
      staticClass: "name ask"
    }, [_vm._v(_vm._s(info.createdByName) + "  " + _vm._s(_vm.keepTime(info.creationTime)))]), _vm._v(" "), (info.content && !(info.messageType == 'FILE')) ? _c('div', {
      staticClass: "cont",
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(info.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (info.messageType && info.messageType == 'FILE') ? _c('div', {
      staticClass: "cont file",
      on: {
        "click": function($event) {
          return _vm.downloadFile(info)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(info.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(info.content))])]) : _vm._e()])])]) : _c('div', {
      staticClass: "cont-box clearfloat"
    }, [_c('div', {
      staticClass: "l content"
    }, [_c('div', {
      staticClass: "name replay"
    }, [_vm._v(_vm._s(info.createdByName) + "  " + _vm._s(_vm.keepTime(info.creationTime)))]), _vm._v(" "), _c('div', {
      staticClass: "cont rep"
    }, [_c('div', {
      staticClass: "rep-cont-box"
    }, [_c('div', [_vm._v(_vm._s(info.map.createdByName) + "  " + _vm._s(_vm.keepTime(info.map.creationTime)))]), _vm._v(" "), (info.map.content && !(info.map.messageType == 'FILE')) ? _c('div', {
      staticClass: "in-img-cont",
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(info.map.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (info.map.messageType && info.map.messageType == 'FILE') ? _c('div', {
      staticClass: "file",
      staticStyle: {
        "padding": "0"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(info.map)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(info.map.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(info.map.content))])]) : _vm._e()]), _vm._v(" "), (info.content && !(info.messageType == 'FILE')) ? _c('div', {
      staticClass: "img-cont",
      domProps: {
        "innerHTML": _vm._s(_vm.analysisContent(info.content))
      },
      on: {
        "click": function($event) {
          return _vm.showImg($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (info.messageType && info.messageType == 'FILE') ? _c('div', {
      staticClass: "file",
      on: {
        "click": function($event) {
          return _vm.downloadFile(info)
        }
      }
    }, [_c('div', {
      staticClass: "v type"
    }, [_vm._v(_vm._s(_vm.obtainFileType(info.content)))]), _vm._v(" "), _c('div', {
      staticClass: "v"
    }, [_vm._v(_vm._s(info.content))])]) : _vm._e()])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.allLoader) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "picture"
    }
  }, [_c('div', {
    staticClass: "piectur-list"
  }, [_vm._l((_vm.histyPictureList), function(item, index) {
    return (_vm.histyPictureList.length) ? _c('div', {
      staticClass: "day-picture"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.handleTimeFormat(item[0].date)))]), _vm._v(" "), _c('div', {
      staticClass: "picture-box"
    }, [_c('div', {
      staticClass: "picture-wrap clearfloat"
    }, _vm._l((item), function(picture) {
      return (item.length) ? _c('div', {
        staticClass: "l picture"
      }, [_c('img', {
        staticClass: "l",
        attrs: {
          "src": picture.filePath
        },
        on: {
          "click": function($event) {
            return _vm.showImg($event)
          }
        }
      })]) : _vm._e()
    }), 0)])]) : _vm._e()
  }), _vm._v(" "), (_vm.allLoader) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文件",
      "name": "file"
    }
  }, [_c('div', {
    staticClass: "file-list"
  }, [_vm._l((_vm.histyFileList), function(item) {
    return (_vm.histyFileList.length) ? _c('div', {
      staticClass: "file-box"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.handleTimeFormat(item[0].date)))]), _vm._v(" "), _vm._l((item), function(file) {
      return (item.length) ? _c('div', {
        staticClass: "file clearfloat",
        on: {
          "click": function($event) {
            return _vm.downloadFile(file)
          }
        }
      }, [_c('div', {
        staticClass: "type l"
      }, [_vm._v(_vm._s(_vm.obtainFileType(file.content)))]), _vm._v(" "), _c('div', {
        staticClass: "cont-box l"
      }, [_c('div', {
        staticClass: "name",
        attrs: {
          "title": file.content
        }
      }, [_vm._v(_vm._s(file.content))]), _vm._v(" "), _c('div', {
        staticClass: "time-name"
      }, [_vm._v(_vm._s(file.time) + "  " + _vm._s(file.createdByName))])])]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), (_vm.allLoader) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "setStyle"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "position": "absolute",
      "top": "60px",
      "right": "15px"
    },
    attrs: {
      "open": _vm.open,
      "value": _vm.sarchDate,
      "confirm": "",
      "type": "date",
      "placement": "bottom-end"
    },
    on: {
      "on-change": _vm.serarchDateChange,
      "on-clear": _vm.serarchDateClear,
      "on-ok": _vm.serarchDateOk
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "blur": _vm.serarchBlur,
      "click": _vm.serarchDateClick
    }
  }, [_c('Icon', {
    attrs: {
      "size": "16",
      "type": "ios-calendar-outline"
    }
  }), _vm._v(" "), (_vm.sarchDate === '') ? void 0 : [_vm._v(_vm._s(_vm.sarchDate))]], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-box"
  }, [_c('Page', {
    attrs: {
      "current": _vm.historyPage.curPage,
      "total": _vm.historyPage.total,
      "simple": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.getPage($event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "closable": false,
      "width": "757px",
      "styles": {
        top: '20px'
      }
    },
    model: {
      value: (_vm.lookPictureModel),
      callback: function($$v) {
        _vm.lookPictureModel = $$v
      },
      expression: "lookPictureModel"
    }
  }, [_c('div', {
    staticClass: "look-picture"
  }, [_c('image-viewer', {
    attrs: {
      "styleObjs": _vm.imageViewerParams.styles,
      "images": _vm.imageViewerParams.recordImgs
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.lookPictureModel = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('consultation-modal', {
    attrs: {
      "fade": _vm.isConsultationModalVisible
    },
    on: {
      "change": function($event) {
        _vm.isConsultationModalVisible = false
      }
    }
  }), _vm._v(" "), _c('complaint-modal', {
    attrs: {
      "fade": _vm.complaintModal.fade
    },
    on: {
      "change": function($event) {
        _vm.complaintModal.fade = false
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [_c('Modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noticeModal.fade),
      expression: "noticeModal.fade"
    }],
    staticClass: "slider-wrapper",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "1200",
      "mask-closable": false,
      "footer-hide": true
    },
    on: {
      "on-cancel": _vm.cancelImgModal
    },
    model: {
      value: (_vm.noticeModal.fade),
      callback: function($$v) {
        _vm.$set(_vm.noticeModal, "fade", $$v)
      },
      expression: "noticeModal.fade"
    }
  }, [_c('div', {
    staticClass: "carousel-cover"
  }, [_c('div', {
    staticClass: "carousel-part carousel-part-lf"
  }, [(_vm.noticeModal.noticeSetting.lfImg) ? _c('img', {
    staticClass: "slide-lf",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.noticeModal.noticeSetting.lfImg,
      "alt": ""
    },
    on: {
      "click": _vm.moveLeft
    }
  }) : _c('img', {
    staticClass: "slide-lf",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../images/default-img.png")
    },
    on: {
      "click": _vm.moveLeft
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-main-box"
  }, [(_vm.noticeModal.fade) ? _c('Carousel', {
    attrs: {
      "arrow": _vm.noticeModal.noticeSetting.arrow,
      "dots": _vm.noticeModal.noticeSetting.dots
    },
    on: {
      "on-change": _vm.changeNotice
    },
    model: {
      value: (_vm.noticeModal.noticeSetting.index),
      callback: function($$v) {
        _vm.$set(_vm.noticeModal.noticeSetting, "index", $$v)
      },
      expression: "noticeModal.noticeSetting.index"
    }
  }, _vm._l((_vm.noticeModal.noticeSetting.data), function(item, index) {
    return _c('CarouselItem', {
      key: index
    }, [_c('div', {
      staticClass: "demo-carousel"
    }, [(item.url) ? _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }) : _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": require("../images/default-img.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "notice-link",
      on: {
        "click": function($event) {
          return _vm.openNewPage($event, item.link)
        }
      }
    })])])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-part carousel-part-rt"
  }, [(_vm.noticeModal.noticeSetting.rtImg) ? _c('img', {
    staticClass: "slide-rt",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.noticeModal.noticeSetting.rtImg,
      "alt": ""
    },
    on: {
      "click": _vm.moveRight
    }
  }) : _c('img', {
    staticClass: "slide-rt",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../images/default-img.png"),
      "alt": ""
    },
    on: {
      "click": _vm.moveRight
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-dots"
  }, [_vm._v(_vm._s(_vm.noticeModal.noticeSetting.index + 1) + "/" + _vm._s(_vm.noticeModal.noticeSetting.data.length))])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "750",
      "title": "客户手册",
      "footer": null
    },
    model: {
      value: (_vm.manual.show),
      callback: function($$v) {
        _vm.$set(_vm.manual, "show", $$v)
      },
      expression: "manual.show"
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.manual.info,
      "width": "100%",
      "height": "600",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('Modal', {
    staticClass: "visitorModal",
    attrs: {
      "title": "联系客服",
      "width": "400"
    },
    model: {
      value: (_vm.visitorModal),
      callback: function($$v) {
        _vm.visitorModal = $$v
      },
      expression: "visitorModal"
    }
  }, [_c('Form', {
    ref: "mobileForm",
    staticClass: "login-form",
    staticStyle: {
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "model": _vm.mobileForm,
      "rules": _vm.mobileFormRules
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "named",
      "label": "称谓：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入称谓"
    },
    model: {
      value: (_vm.mobileForm.named),
      callback: function($$v) {
        _vm.$set(_vm.mobileForm, "named", $$v)
      },
      expression: "mobileForm.named"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "mobilePhone",
      "label": "手机号：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.mobileForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.mobileForm, "mobilePhone", $$v)
      },
      expression: "mobileForm.mobilePhone"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "loading": _vm.codeLoading
    },
    on: {
      "click": _vm.getCode
    },
    slot: "append"
  }, [(_vm.codeLoading) ? _c('span', {
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("(" + _vm._s(_vm.codeLoadingCount) + ")重新发送")]) : _c('span', [_vm._v("获取验证码")])])], 1)], 1), _vm._v(" "), _c('vcode', {
    ref: "vcode",
    attrs: {
      "templetCode": "SUPPORT-CAPTCHA",
      "mateCode": "HARBOUR",
      "showIcon": false
    },
    on: {
      "finished": _vm.sentVcode
    }
  }), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "code",
      "label": "验证码：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.mobileForm.code),
      callback: function($$v) {
        _vm.$set(_vm.mobileForm, "code", $$v)
      },
      expression: "mobileForm.code"
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "login-btn",
    staticStyle: {
      "background": "#02CAD6",
      "color": "#fff"
    },
    attrs: {
      "long": "",
      "loading": _vm.loginLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('mobileForm')
      }
    }
  }, [_c('span', [_vm._v("确定")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6b4052a9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b4052a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/chat-pop.vue
// module id = 1367
// module chunks = 61